import React from 'react';

const ABCAnalysisDashboard: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">ABC分析ダッシュボード</h1>
      <p className="text-gray-600 mt-4">
        一時的にシンプルなバージョンでエラーをテストしています。
      </p>
    </div>
  );
};

export default ABCAnalysisDashboard;